import { transition, trigger, useAnimation } from '@angular/animations';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { pulseUpdate } from '../../../shared/animations/pulse.animation';
import { LightLocationModel } from './lights-store/lights.actions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-light-ui',
  templateUrl: './light.component.html',
  animations: [trigger('pulse', [transition('* => *', [useAnimation(pulseUpdate)])])],
  imports: [FaIconComponent],
})
export class LightComponent {
  readonly light = input.required<LightLocationModel>();
}
